const ACTIONS = {
  CLEAR_CHANGE_PASSWORD_MODAL: 'clear_change_password_modal',
  HANDLE_LEAD: 'handle_lead',
  RESET_CALCULATED_FINANCING_DATA: 'reset_calculated_financing_data',
  SET_CALCULATED_FINANCING_DATA: 'set_calculated_financing_data',
  SET_INITIAL_LEAD_ENRICHMENT: 'set_initial_lead_enrichment',
  SET_IS_FAVORITE: 'set_is_favorite',
  SET_OFFSET_TOP: 'set_offset_top',
  SET_SHOW_MODAL: 'set_show_modal',
  SET_SUBSCRIPTION_PRICE_OPTION_SELECTED: 'set_subscription_price_option_selected',
  SET_USER_DATA: 'set_user_data',
  UPDATE_LEAD_DATA: 'update_lead_data'
}

const INITIAL_STATE = {
  initialLeadEnrichmentValue: [],
  autoGeneratedPassword: null,
  calculatedFinancingData: undefined,
  contactType: '',
  errorData: {},
  hasCalculatedFinancingData: false,
  isFavorite: false,
  offsetTop: 0,
  relatedAds: [],
  showModal: false,
  subscriptionPriceOptionSelected: undefined,
  userHasBeenRegistered: false,
  userData: {}
}

const reducer = (state, {type, payload}) => {
  switch (type) {
    case ACTIONS.CLEAR_CHANGE_PASSWORD_MODAL:
      return {
        ...state,
        userHasBeenRegistered: false,
        autoGeneratedPassword: null
      }
    case ACTIONS.HANDLE_LEAD:
      return {
        ...state,
        autoGeneratedPassword: payload.autoGeneratedPassword ?? null,
        contactType: payload.contactType,
        showModal: payload.showModal,
        userHasBeenRegistered: payload.userHasBeenRegistered ?? false
      }
    case ACTIONS.RESET_CALCULATED_FINANCING_DATA:
      return {
        ...state,
        calculatedFinancingData: INITIAL_STATE.calculatedFinancingData,
        hasCalculatedFinancingData: INITIAL_STATE.hasCalculatedFinancingData
      }
    case ACTIONS.SET_CALCULATED_FINANCING_DATA:
      return {
        ...state,
        calculatedFinancingData: payload.calculatedFinancingData,
        hasCalculatedFinancingData: true
      }
    case ACTIONS.SET_IS_FAVORITE:
      return {
        ...state,
        isFavorite: payload.isFavorite
      }
    case ACTIONS.SET_OFFSET_TOP:
      return {
        ...state,
        offsetTop: payload.offsetTop
      }
    case ACTIONS.SET_SHOW_MODAL:
      return {
        ...state,
        showModal: payload.showModal
      }
    case ACTIONS.SET_USER_DATA:
      return {
        ...state,
        userData: payload.userData
      }
    case ACTIONS.SET_INITIAL_LEAD_ENRICHMENT: {
      return {...state, initialLeadEnrichmentValue: payload.initialLeadEnrichmentValue}
    }
    case ACTIONS.SET_SUBSCRIPTION_PRICE_OPTION_SELECTED: {
      return {
        ...state,
        subscriptionPriceOptionSelected: payload.subscriptionPriceOptionSelected,
        targetBuyer: payload.subscriptionPriceOptionSelected?.targetBuyer,
        selectedTabAdInfo: payload.selectedTabAdInfo
      }
    }
    case ACTIONS.UPDATE_LEAD_DATA: {
      return {...state, leadData: payload.leadData}
    }

    default:
      return state
  }
}

export {ACTIONS as reducerActions, INITIAL_STATE as reducerInitialState, reducer}
